import { createFileRoute } from '@tanstack/react-router'
import CreateOrEditStateLienRightsRequirements from '../components/lien-rights-requirements/CreateOrEditStateLienRightsRequirements'

export const Route = createFileRoute('/_a/lienRightsRequirements/$state')({
  component: CreateOrEditStateLienRightsRequirements,
})
